import React, {Component} from 'react';
import Action from 'actions';
import Const from 'constants';
import {generateRandomKey} from 'helpers/hash';
import {toFloat} from 'helpers/number-helper';

class BaseComponent extends Component {
    isStateReady(state, data = null) {
        if (state.error) {
            console.error('BaseComponent ERR: ', state);
            return false;
        }

        if (data) {
            return !state.loading && !isEmpty(state[data]);
        }

        return !state.loading;
    }

    loadPlayersDataFromStorage() {
        this.props.dispatch(Action.loadFiltersFromStorage('playersData'));
    }

    loadSlate() {
        const {sportConfig} = this.props;
        if (sportConfig.hasSlateId()) {
            this.props.dispatch(Action.get('Slate', sportConfig.getSlateId(), sportConfig.getSport()));
        }
    }

    loadSlateIfGamesNotLoaded() {
        const {games} = this.props;

        if (!games.isLoading() && !games.isLoaded()) {
            this.loadSlate();
        }
    }

    loadSlateIfPlayersNotLoaded() {
        const {players} = this.props;

        if (!players.isLoading() && !players.hasPlayers()) {
            this.loadSlate();
        }
    }

    loadSlatesIfAbsent() {
        const {slates} = this.props;
        if (!slates.hasItems()) {
            this.loadSlates();
        }
    }

    loadSlates() {
        const {sportConfig} = this.props;
        if (sportConfig.hasSite() && sportConfig.hasSport()) {
            this.props.dispatch(Action.get('Slates', sportConfig.getSport(), sportConfig.getSite()));
        }
    }

    loadSportConfig() {
        const {sportConfig} = this.props;

        if (!sportConfig.isLoading() && sportConfig.hasSite() && sportConfig.hasSport()) {
            this.props.dispatch(
                Action.get(
                    'SportConfig',
                    sportConfig.getSport(),
                    sportConfig.getSite(),
                    sportConfig.getGameType(),
                    sportConfig.getMode(),
                ),
            );
        }
    }

    subscribeToSlateLiveUpdates() {
        const {sportConfig, socketIO} = this.props;
        if (sportConfig.hasSlateId() && !socketIO.isSubscribed()) {
            this.props.dispatch(Action.do('subscribeToSlateLiveUpdates', sportConfig.getSlateId()));
        }
    }

    getRenderKey() {
        return generateRandomKey();
    }

    isMainMode() {
        const {sportConfig} = this.props;

        return sportConfig.isModeMain();
    }

    getFinalPointsInfo(params = {}) {
        const {points, className} = params;

        if (this.isMainMode()) {
            return null;
        }

        return (
            <li className={className}>
                <strong>Final FPts:</strong> {toFloat(points, 3)}
            </li>
        );
    }
}

export {BaseComponent};
